import { RootAction } from '@src/app/_redux';
import { NAME_ADDRESS_LOGIN_INITIATE } from '@src/app/login/weak/nameaddress/actions';
import { combineReducers } from 'redux';

export type State = {
  firstName: string;
  lastName: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;

  captureEmail: string;
  emailOptIn: string;
};

export const reducer = combineReducers<State, RootAction>({
  firstName: (state = '', action) => {
    switch (action.type) {
      case NAME_ADDRESS_LOGIN_INITIATE:
        return action.payload.firstName;
      default:
        return state;
    }
  },
  lastName: (state = '', action) => {
    switch (action.type) {
      case NAME_ADDRESS_LOGIN_INITIATE:
        return action.payload.lastName;
      default:
        return state;
    }
  },
  address1: (state = '', action) => {
    switch (action.type) {
      case NAME_ADDRESS_LOGIN_INITIATE:
        return action.payload.address1;
      default:
        return state;
    }
  },
  address2: (state = '', action) => {
    switch (action.type) {
      case NAME_ADDRESS_LOGIN_INITIATE:
        if (action.payload.address2) {
          // address2 is optional
          return action.payload.address2;
        } else {
          return state;
        }
      default:
        return state;
    }
  },
  city: (state = '', action) => {
    switch (action.type) {
      case NAME_ADDRESS_LOGIN_INITIATE:
        return action.payload.city;
      default:
        return state;
    }
  },
  state: (state = '', action) => {
    switch (action.type) {
      case NAME_ADDRESS_LOGIN_INITIATE:
        return action.payload.state;
      default:
        return state;
    }
  },
  postalCode: (state = '', action) => {
    switch (action.type) {
      case NAME_ADDRESS_LOGIN_INITIATE:
        return action.payload.postalCode;
      default:
        return state;
    }
  },
  country: (state = '', action) => {
    switch (action.type) {
      case NAME_ADDRESS_LOGIN_INITIATE:
        return action.payload.country;
      default:
        return state;
    }
  },
  captureEmail: (state = '', action) => {
    switch (action.type) {
      case NAME_ADDRESS_LOGIN_INITIATE:
        return action.payload.captureEmail;
      default:
        return state;
    }
  },
  emailOptIn: (state = '', action) => {
    switch (action.type) {
      case NAME_ADDRESS_LOGIN_INITIATE:
        return action.payload.emailOptIn;
      default:
        return state;
    }
  },
});
